import { useEffect, useState } from "react";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { ColumnItem } from "../../../common/models/table";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { ContainerTypeService } from "./core/_request";
import { HttpStatusCode } from "axios";
import {
  useContainerTypeListState,
  useContainerTypeStore,
} from "./store/ContainerTypeStore";
import { Loader } from "../../../common/components/Loader/Loader";

import { ContainerTypeForm } from "./ContainerTypeForm";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";

const ContainerTypeList = () => {
  const {
    setContainerTypeList,
    containerTypeList,
    actioned,
    totalItems,
    setActioned,
  } = useContainerTypeStore();
  const { pageState, setPageState, resetPageState } =
    useContainerTypeListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "containerUnit",
      title: "Dimension",
      dataIndex: "containerUnit",
      show: true,
      nestedKey: "containerUnit.id",
      isCanSort: true,
      /* searchType: "select",
      searchOptions: dimensionOptions,
      isLoading: isLoadingDimension, */
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "containerCategory",
      title: "Catégorie",
      dataIndex: "containerCategory",
      show: true,
      isCanSort: true,
      nestedKey: "containerCategory.id",
      /* searchType: "select",
      searchOptions: categoryOptions,
      isLoading: isLoadingCategory, */
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "abbreviation",
      title: "Abbreviation",
      dataIndex: "abbreviation",
      show: true,
      isCanSort: true,
      //nestedKey: "containerCategory.id",
      /* searchType: "select",
      searchOptions: categoryOptions,
      isLoading: isLoadingCategory, */
      /* render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      }, */
    },
  ];

  useEffect(() => {
    fetchAllContainerTypes(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onClickOnAdd = () => {
    onShowAddHandler();
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await ContainerTypeService.getContainerTypeById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await ContainerTypeService.deleteContainerType(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllContainerTypes();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllContainerTypes = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await ContainerTypeService.getContainerTypeList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setContainerTypeList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader
        title="Types de conteneur"
        // isSHowBack
        isEnableAdd
        onClickOnAdd={onClickOnAdd}
      />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={containerTypeList}
            params={pageState}
            onAction={onActionClick}
            // isCanDelete={() => true}
            isCanEdit={() => true}
            onSearch={handleSetParams}
            onSort={handleSetParams}
            onResetSearch={resetPageState}
            onChangePage={handleSetParams}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <ContainerTypeForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};

export default ContainerTypeList;
